module.exports = __webpack_public_path__ + "static/media/logo_electricity_monitoring.30e40508.svg";